import { OfflineBolt } from '@mui/icons-material';
import { Box, Card, CardContent, lighten } from '@mui/material';

import { Divider, Typography } from '@occc/ui-design-system';
import { Flow_Types } from '@occc-app/offerHelpers/types';
import { CampaignComponentFooterActions } from '@occc-app/routes/CampaignComponents/components/CampaignComponentFooterActions';
import { CampaignComponentReadOnlyFooterActions } from '@occc-app/routes/CampaignComponents/components/CampaignComponentReadOnlyFooterActions';
import { ScheduleDates } from '@occc-app/routes/CampaignComponents/components/ScheduleDates';
import TriggerOnFulfillment from '@occc-app/routes/CampaignComponents/components/TriggerOnFulfillment/TriggerOnFulfillment';
import TriggerOnOfferVisibilityChange from '@occc-app/routes/CampaignComponents/components/TriggerOnOfferVisibilityChange/TriggerOnOfferVisibilityChange';

import { FormLayout } from '@occc-app/routes/CampaignComponents/components/FormLayout';
import { FinalizeFormValues } from '../../types';

type FinalizeFormContentProps = {
  values: FinalizeFormValues;
  isReadOnlyRole: boolean;
  currentFlowType: Flow_Types;
  submitting?: boolean;
  dirty?: boolean;
  handleNextButtonClick: () => void;
  handleCancel?: () => void;
  isLoading?: boolean;
};

export const FinalizeFormContent = ({
  values,
  isReadOnlyRole,
  currentFlowType,
  handleNextButtonClick,
  handleCancel,
  submitting = false,
  dirty = false,
  isLoading,
}: FinalizeFormContentProps) => {
  const formFooterActionButtons = isReadOnlyRole ? (
    <CampaignComponentReadOnlyFooterActions
      onCancel={handleCancel ?? (() => {})}
      onNextStepClick={handleNextButtonClick}
    />
  ) : (
    <CampaignComponentFooterActions
      currentFlowType={currentFlowType}
      onCancel={handleCancel ?? (() => {})}
      isSubmitDisabled={submitting || (currentFlowType === Flow_Types.Update && !dirty)}
    />
  );

  return (
    <FormLayout actions={formFooterActionButtons} type='primary' isLoading={isLoading}>
      <Card>
        <CardContent>
          <Box
            p={3}
            mb={3}
            bgcolor={({ palette }) => lighten(palette.primary.main, 0.9)}
            borderRadius={2}
          >
            <Typography variant='h6' component='h4' paragraph display='flex'>
              <OfflineBolt color='primary' sx={{ mr: 1 }} />
              Finalize Your Award
            </Typography>
            <Typography>
              Awards represent an item, discount, or experience that can either be purchased with
              points, or awarded as part of an Offer (e.g. Buy 5 cups of coffee, get one free).
              Please note, that when you click "Finalize" this benefit will be available as an award
              when creating Campaign specific Offers and Rewards, and will remain available until it
              is manually archived.
            </Typography>
          </Box>
          <Box my={3}>
            <ScheduleDates values={values} />
          </Box>
          <Divider />
          <TriggerOnOfferVisibilityChange open={values?.triggerPreferences?.triggerOnVisibility} />
          <Divider />
          <TriggerOnFulfillment open={values?.triggerPreferences?.triggerOnFulfillment} />
        </CardContent>
      </Card>
    </FormLayout>
  );
};
